import React from 'react';
import {View} from 'react-native';
import {noop} from 'lodash';

import Banner from '/component/base/Banner';
import Text from '/component/base/Text';

import {styles} from './LabelBanner.style';

interface LabelBannerProps {
  style: {
    base: {};
    contentContainer: {};
    label: {};
    labelText: {};
  };
  alertLevel: 'low' | 'info' | 'important' | 'success' | 'error';
  useCompetency: boolean;
  bannerClose: () => void;
  label: string;
  heading: string;
  children: {};
}

export const LabelBanner: React.FC<LabelBannerProps> = ({
  style: styleProp = {
    base: {},
    contentContainer: {},
    label: {},
    labelText: {},
  },
  alertLevel = 'info',
  useCompetency = false,
  bannerClose = noop,
  label = '',
  heading = '',
  children = null,
}) => {
  return (
    <Banner
      style={{...styles.base, ...(styleProp.base || {})}}
      alertLevel={alertLevel}
      useCompetency={useCompetency}
      bannerClose={bannerClose}>
      <View
        style={{
          ...styles.contentContainer,
          ...(styleProp.contentContainer || {}),
        }}>
        <View style={{...styles.label, ...(styleProp.label || {})}}>
          <Text
            variant="caption"
            style={{...styles.labelText, ...(styleProp.labelText || {})}}>
            {label}
          </Text>
        </View>
        <Text variant="heading" style={styles.text}>
          {heading}
        </Text>
        {children}
      </View>
    </Banner>
  );
};
export default LabelBanner;
